// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'
const config = useJwt.jwtConfig
const headers = {
  token: localStorage.getItem(config.storageTokenKeyName),
  userID: localStorage.getItem('userID')
}


// export const getPaymentType = createAsyncThunk('appPricing/getPaymentType', async () => {
//   const response = await axios.post(' https://api.zasway.com:8443/Common/GePreferFromList')
//   return response.data
//   })

//  export const getPaymentType = createAsyncThunk('appPricing/getPaymentType', async () => {
//     const response = await axios.post(' https://api.zasway.com:8443/Common/GePreferFromList')
//     return response.data
//    })


export const addPricing = createAsyncThunk('appDrvrPayment/Create', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/Create', params, { mode: 'cors' })

  return response
})

export const addPayment = createAsyncThunk('appDrvrPayment/Create', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/Create', params, { mode: 'cors' })
  return response
})

export const addVehicleOverride = createAsyncThunk('appDrvrPayment/createVehicleOverride', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/CreateVehicleOverride', params, { mode: 'cors' })

  return response
})

export const addPeakTimes = createAsyncThunk('appDrvrPayment/createPeakTime', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/CreatePeakTime', params, { mode: 'cors' })

  return response
})

export const addPeakPeriods = createAsyncThunk('appDrvrPayment/createPeakPeriod', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/CreatePeakPeriod', params, { mode: 'cors' })

  return response
})

export const addBonus = createAsyncThunk('appDrvrPayment/createBonus', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/CreateBonus', params, { mode: 'cors' })

  return response
})

export const getClientList = createAsyncThunk('appDrvrPayment/getClientList', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
  return response.data
})

export const getDrvrPymntList = createAsyncThunk('appDrvrPayment/getDriverPayment', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPayment', params)

  return response.data
})

export const getDrvrPymntOwnCarMileageList = createAsyncThunk('appDrvrPayment/getDrvrPymntOwnCarMileage', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPymntOwnCarMileage', params)

  return response.data
})

export const getDrvrPymntVehicleCompanyCarMileageList = createAsyncThunk('appDrvrPayment/getDrvrPymntVehicleCompanyCarMileage', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPymntVehicleCompanyCarMileage', params)

  return response.data
})

export const getDriverPaymentPeakPeriodList = createAsyncThunk('appDrvrPayment/getDriverPaymentPeakPeriod', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPaymentPeakPeriod', params)
  return {
    params,
    data: response.data
  }
})
export const GetDriverPaymentID = createAsyncThunk('appDrvrPayment/GetDriverPaymentID', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPaymentID', params)
  return {
    params,
    data: response.data
  }
})

export const getDriverPaymentPeakTimesList = createAsyncThunk('appDrvrPayment/getDriverPaymentPeakTimes', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPaymentPeakTimes', params)
  return {
    params,
    data: response.data
  }
})

export const getDrvrPaymentClientList = createAsyncThunk('appDrvrPayment/getDrvrPaymentClient', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPaymentClient', params)

  return {
    params,
    data: response.data
  }
})

export const getDrvrPymntVehicleOwnCarMileageList = createAsyncThunk('appDrvrPayment/getDrvrPymntVehicleOwnCarMileage', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPymntVehicleOwnCarMileage', params)

  return response.data
})

export const getDrvrPymntCompanyCarMileageList = createAsyncThunk('appDrvrPayment/getDrvrPymntCompanyCarMileage', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPymntCompanyCarMileage', params)

  return response.data
})

export const getPreferFrom = createAsyncThunk('appPricing/getPreferFrom', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GePreferFromList')
  return response.data
})

export const getDriverPaymentBonus = createAsyncThunk('appDrvrPayment/getDriverPaymentBonus', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPaymentBonus', params)

  return {
    params,
    data: response.data.bonusMaster,
    dtlData: response.data.bonusDetail
  }
})

export const getPaymentType = createAsyncThunk('appDrvrPayment/getPaymentTypeList', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetPaymentTypeList')
  return response.data
})

export const getCOAPricingType = createAsyncThunk('appDrvrPayment/getCOAPricingTypeList', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetCOAPricingTypeList')
  return response.data
})

export const getDeadMileageMode = createAsyncThunk('appDrvrPayment/getDeadMileageModeList', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetDeadMileageModeList')
  return response.data
})

export const getMileageStepsMode = createAsyncThunk('appPricing/getMileageStepsMode', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetMileageStepsModeList')
  return response.data
})

export const getInheritZone = createAsyncThunk('appPricing/getZoneList', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/Common/GetZoneList', params, { mode: 'cors' })
  return response.data
})

export const getBookingStatus = createAsyncThunk('appPricing/getBookingStatusList', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetBookingStatusList')
  return response.data
})

export const DeleteClients = createAsyncThunk('appPricing/DeleteClients', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/DeleteDrvrPaymentClient', params, { mode: 'cors' })
  return response.data
})

export const getBaseToBaseMode = createAsyncThunk('appPricing/getMileageStepsMode', async () => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetMileageStepsModeList')
  return response.data
})

export const getNationality = createAsyncThunk('appStaff/getNationality', async () => {

  const response = await axios.get(' https://api.zasway.com:8443/Common/GetNationalityList', { headers })
  return response.data
})

export const getDependsUpon = createAsyncThunk('appDrvrPayment/getDependsUponList', async () => {

  const response = await axios.get(' https://api.zasway.com:8443/Common/GetDependsUponList')
  return response.data
})

export const getVehicleType = createAsyncThunk('appPricing/getVehicleTypeList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Common/GetVehicleTypeListForDriverPayment', params, { mode: 'cors' })
  return response.data
})
export const AddClients = createAsyncThunk('appPricing/getVehicleTypeList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/AddDrvrPaymentClient', params, { mode: 'cors' })
  return response.data
})

export const getAllData = createAsyncThunk('appStaff/GetTableSummary', async (GetStaff) => {

  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetTableSummary', GetStaff, { mode: 'cors' })

  return response.data
})
export const getStaffStats = createAsyncThunk('appStaff/GetStaffStatistics', async (GetStaff) => {

  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetStaffStatistics', GetStaff, { mode: 'cors' })

  return response.data
})
export const getData = createAsyncThunk('appStaff/getData', async (params) => {


  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const getDrvrPaymentsLst = createAsyncThunk('appDrvrPayment/getDrvrPayments', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPayments', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data
  }
})

export const getDrvrPaymentsCashLst = createAsyncThunk('appDrvrPayment/getDrvrCashPayments', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPayments', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data
  }
})

export const getDrvrPaymentsCardLst = createAsyncThunk('appDrvrPayment/getDrvrCardPayments', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPayments', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data
  }
})

export const getDrvrPaymentsVehicleTypeLst = createAsyncThunk('appDrvrPayment/getDriverPaymentVehicleType', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDriverPaymentVehicleType', params, { mode: 'cors' })

  return {
    params,
    data: response.data
  }
})

export const getDrvrPaymentsVehicleOverrideLst = createAsyncThunk('appDrvrPayment/getDrvrPaymentVehicleOveride', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPaymentVehicleOveride', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data
  }
})

export const getDrvrPaymentsVehicleOverrideCashLst = createAsyncThunk('appDrvrPayment/getDrvrPaymentVehicleOverideCash', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPaymentVehicleOveride', params, { mode: 'cors' })
  return {
    params,
    data: response.data.data
  }
})

export const getDrvrPaymentsVehicleOverrideCardLst = createAsyncThunk('appDrvrPayment/getDrvrPaymentVehicleOverideCard', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/GetDrvrPaymentVehicleOveride', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data
  }
})

export const updateVehicleOverride = createAsyncThunk('appDrvrPayment/updateVehicleOverride', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/UpdateVehicleOverride', params, { mode: 'cors' })
  return response
})

export const updateDriverPayment = createAsyncThunk('appDrvrPayment/Update', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/Update', params, { mode: 'cors' })
  return response
})

export const deleteDriverPayment = createAsyncThunk('appDrvrPayment/Delete', async (id) => {

  const response = await axios.post(' https://api.zasway.com:8443/DriverPayment/Delete', id, { mode: 'cors' })

  // await dispatch(getDrvrPymntList())
  return response
})


export const getStaff = createAsyncThunk('appStaff/getStaff', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Staff/GetTableSummary', params, { mode: 'cors' })

  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})
export const EditStaff = createAsyncThunk('appStaff/Update', async (Staff) => {

  const response = await axios.post(' https://api.zasway.com:8443/Staff/Update', Staff, { mode: 'cors' })

  return response
})
export const deleteStaff = createAsyncThunk('appStaff/Delete', async (id, { dispatch, getState }) => {

  const response = await axios.post(' https://api.zasway.com:8443/Staff/Delete', id, { mode: 'cors' })

  await dispatch(getData(getState().staff.params))

  return response
})

export const getUser = createAsyncThunk('appStaff/getUser', async () => {

  const response = await axios.get(' https://api.zasway.com:8443/Vendor/GetVendorList', { headers }, data)
  return response.data
})

export const addUser = createAsyncThunk('appStaff/addUser', async (user, { dispatch, getState }) => {

  await axios.post(' https://api.zasway.com:8443/User/CreateUser', user, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().staff.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appStaff/deleteUser', async (id, { dispatch, getState }) => {

  await axios.post(' https://api.zasway.com:8443/User/DeleteUser', { id }, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().staff.params))
  await dispatch(getAllData())
  return id
})
export const getStaffImage = createAsyncThunk('appDriver/GetStaffImage', async (Staff) => {

  const response = await axios.post(' https://api.zasway.com:8443/Common/GetStaffImage', Staff, { mode: 'cors' })
  return response.data
})
export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {

  const response = await axios.post(' https://api.zasway.com:8443/Common/UploadImageStaff', formData, { mode: 'cors' })

  return response
})

export const resetPaymentID = createAsyncThunk('appDrvrPayment/resetPaymentID', async () => {
  return { data: 0 }
})

export const setPaymentID = createAsyncThunk('appDrvrPayment/setPaymentID', async (id) => {

  return {
    code: 200,
    DriverPaymentID: parseInt(id.id),
    ClientID: 0,
    ClientDriverPaymentID: parseInt(id.id)
  }
})
export const updateBonus = createAsyncThunk('appDrvrPayment/UpdateBonus', async (params) => {

  const response = await axios.post(' https://api.zasway.com:8443/UpdateBonus', params, { mode: 'cors' })
  return response
})
export const setClientID = createAsyncThunk('appDrvrPayment/setClientID', async (data) => {
  return { data }
})

export const setClientDriverPaymentID = createAsyncThunk('appDrvrPayment/setClientDriverPaymentID', async (data) => {
  return { data }
})
export const appDrvrPaymentSlice = createSlice({
  name: 'appDrvrPayment',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    DriverPaymentID: 0,
    ClientId: 0,
    ClientDriverPaymentID: 0,
    DrvrPaymentData: [],
    DrvrPaymentParams: {},
    DrvrPaymentCashData: [],
    DrvrPaymentCashParams: {},
    DrvrPaymentCardData: [],
    DrvrPaymentCardParams: {},
    DrvrPaymentVehicleTypeData: [],
    DrvrPaymentVehicleTypeParams: {},
    DrvrPaymentClientData: [],
    DrvrPaymentClientParams: {},
    DrvrPaymentVehicleOverrideData: [],
    DrvrPaymentVehicleOverrideParams: {},
    DrvrPaymentVehicleOverrideCashData: [],
    DrvrPaymentVehicleOverrideCashParams: {},
    DrvrPaymentVehicleOverrideCardData: [],
    DrvrPaymentVehicleOverrideCardParams: {},
    DrvrPaymentPeakPeriodData: [],
    DrvrPaymentPeakPeriodParams: {},
    DrvrPaymentPeakTimesData: [],
    DrvrPaymentPeakTimesParams: {},
    DrvrPaymentBonusData: [],
    DrvrPaymentBonusDtlData: [],
    DrvrPaymentBonusParams: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
      .addCase(getStaff.fulfilled, (state, action) => {
        state.selectedUser = action.payload.allData[0]
      })
      .addCase(getDrvrPaymentsLst.fulfilled, (state, action) => {

        state.DrvrPaymentData = action.payload.data
        state.DrvrPaymentParams = action.payload.params
      })
      .addCase(getDrvrPaymentsCardLst.fulfilled, (state, action) => {

        state.DrvrPaymentCardData = action.payload.data
        state.DrvrPaymentCardParams = action.payload.params
      })
      .addCase(getDrvrPaymentsVehicleTypeLst.fulfilled, (state, action) => {

        state.DrvrPaymentVehicleTypeData = action.payload.data
        state.DrvrPaymentVehicleTypeParams = action.payload.params
      })
      .addCase(getDrvrPaymentClientList.fulfilled, (state, action) => {

        state.DrvrPaymentClientData = action.payload.data
        state.DrvrPaymentClientParams = action.payload.params
      })
      .addCase(getDrvrPaymentsCashLst.fulfilled, (state, action) => {

        state.DrvrPaymentCashData = action.payload.data
        state.DrvrPaymentCashParams = action.payload.params
      })
      .addCase(getDrvrPaymentsVehicleOverrideLst.fulfilled, (state, action) => {

        state.DrvrPaymentVehicleOverrideData = action.payload.data
        state.DrvrPaymentVehicleOverrideParams = action.payload.params
      })
      .addCase(getDrvrPaymentsVehicleOverrideCashLst.fulfilled, (state, action) => {

        state.DrvrPaymentVehicleOverrideCashData = action.payload.data
        state.DrvrPaymentVehicleOverrideCashParams = action.payload.params
      })
      .addCase(getDrvrPaymentsVehicleOverrideCardLst.fulfilled, (state, action) => {

        state.DrvrPaymentVehicleOverrideCardData = action.payload.data
        state.DrvrPaymentVehicleOverrideCardParams = action.payload.params
      })
      .addCase(getDriverPaymentPeakPeriodList.fulfilled, (state, action) => {
        state.DrvrPaymentPeakPeriodData = action.payload.data
        state.DrvrPaymentPeakPeriodParams = action.payload.params
      })
      .addCase(getDriverPaymentPeakTimesList.fulfilled, (state, action) => {
        state.DrvrPaymentPeakTimesData = action.payload.data
        state.DrvrPaymentPeakTimesParams = action.payload.params
      })
      .addCase(setPaymentID.fulfilled, (state, action) => {

        state.DriverPaymentID = action.payload.DriverPaymentID
        state.ClientId = action.payload.ClientID
        state.ClientDriverPaymentID = action.payload.ClientDriverPaymentID
      })
      .addCase(setClientID.fulfilled, (state, action) => {
        state.ClientId = action.payload.data.clientID
      })
      .addCase(setClientDriverPaymentID.fulfilled, (state, action) => {

        state.ClientDriverPaymentID = state.ClientId > 0 ? action.payload.data.id : 0
      })
      .addCase(addPayment.fulfilled, (state, action) => {

        state.DriverPaymentID = action.payload.data.id
        state.ClientDriverPaymentID = action.payload.data.clientID > 0 ? action.payload.data.id : 0
      })
      .addCase(getDriverPaymentBonus.fulfilled, (state, action) => {

        state.DrvrPaymentBonusData = action.payload.data
        state.DrvrPaymentBonusDtlData = action.payload.dtlData
        state.DrvrPaymentBonusParams = action.payload.params
      })
  }
})

export default appDrvrPaymentSlice.reducer
